import { FhsAPI } from "../../../services/axios";

const state = {
  status_code: ""
};

const getters = {
  getStatusCode: state => state.status_code
};

const mutations = {
  setStatusCode(state, payload) {
    state.status_code = payload;
  }
};

const actions = {
  sendRefreshToken({ commit }) {
    FhsAPI.auth.refreshToken().then(res => {
      commit("setTokenData", res);
    });
  }
};

export const _status_code = {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};
